export const ASSETS = [
  { key: 'leftFileUrl', fileName: 'Left.svg' },
  { key: 'rightFileUrl', fileName: 'Right.svg' },
  { key: 'backgroundFileUrl', fileName: 'Background.svg' },
  { key: 'lottieFileUrl', fileName: 'Lottie.json' }
];
